/**
 * Размер файла человеческим текстом: `3565158` → «3,4 МБ».
 *
 * Форматтер один на всё приложение намеренно. До него их было два — тосты про
 * сжатие делили на 1024 и писали «МБ», подпись под картинкой в дропзоне делила
 * на 1000 и писала «Mb», — и один и тот же файл получал на одном экране два
 * разных числа. Расхождение мелкое, но оно ровно про то, чему человек должен
 * верить: сколько весит то, что он сейчас отправит.
 *
 * Основание 1024 — то же, что показывают проводник и Finder, когда сообщают вес
 * файла; расходиться с ними незачем.
 */

const UNITS = ['Б', 'КБ', 'МБ', 'ГБ'];
const STEP = 1024;
const DECIMALS = 1;

function round(value: number): number {
  const factor = 10 ** DECIMALS;
  return Math.round(value * factor) / factor;
}

export function formatBytes(bytes: number): string {
  // Размер приходит и из `File.size`, и из полей бэкенда, где его может не быть
  // вовсе. «NaN Б» под картинкой хуже, чем честный ноль.
  if (!Number.isFinite(bytes) || bytes <= 0) return `0 ${UNITS[0]}`;

  let unitIndex = 0;
  let value = bytes;

  // Сравнивается уже округлённое значение: 1048575 Б — это 1023,999 КБ, что
  // после округления даёт «1024 КБ». Рядом с живым мегабайтом такая подпись
  // читается как ошибка, поэтому в этом случае переходим на единицу выше.
  while (unitIndex < UNITS.length - 1 && round(value) >= STEP) {
    value /= STEP;
    unitIndex += 1;
  }

  // Запятая ставится заменой символа, а не через `toLocaleString('ru-RU')`:
  // его результат зависит от сборки ICU в Node, и тест, зелёный на машине
  // разработчика, падал бы в CI.
  return `${String(round(value)).replace('.', ',')} ${UNITS[unitIndex]}`;
}
